import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Square, Trash2 } from 'lucide-react';

const pickType = () => ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg'].find((t) => window.MediaRecorder?.isTypeSupported?.(t)) || '';

// Começa a gravar ao abrir (máx 5 min); "parar" envia a nota de voz, o caixote cancela
export const VoiceRecorder = ({ onRecorded, onCancel }) => {
  const [secs, setSecs] = useState(0);
  const mr = useRef(null);
  const timer = useRef(null);
  const cancelled = useRef(false);

  useEffect(() => {
    let stream; const chunks = []; let alive = true;
    (async () => {
      if (!navigator.mediaDevices?.getUserMedia || !window.MediaRecorder) { toast.error('Este navegador não permite gravar áudio'); onCancel(); return; }
      try { stream = await navigator.mediaDevices.getUserMedia({ audio: true }); } catch { if (alive) { toast.error('Sem acesso ao microfone. Autorize o microfone no navegador.'); onCancel(); } return; }
      if (!alive) { stream.getTracks().forEach((t) => t.stop()); return; }
      const type = pickType();
      const rec = new MediaRecorder(stream, type ? { mimeType: type } : undefined);
      const t0 = Date.now();
      rec.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      rec.onstop = () => {
        stream.getTracks().forEach((t) => t.stop());
        clearInterval(timer.current);
        if (cancelled.current || !chunks.length) { if (alive) onCancel(); return; }
        const mime = (rec.mimeType || type || 'audio/webm').split(';')[0];
        const ext = mime.includes('mp4') ? 'm4a' : mime.includes('ogg') ? 'ogg' : 'webm';
        onRecorded(new File(chunks, `nota-de-voz.${ext}`, { type: mime }), Math.round((Date.now() - t0) / 1000));
      };
      rec.start(250);
      mr.current = rec;
      timer.current = setInterval(() => setSecs((s) => { if (s + 1 >= 300 && rec.state === 'recording') rec.stop(); return s + 1; }), 1000);
    })();
    return () => { alive = false; clearInterval(timer.current); if (mr.current?.state === 'recording') { cancelled.current = true; mr.current.stop(); } stream?.getTracks().forEach((t) => t.stop()); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const stop = (cancel) => {
    cancelled.current = cancel;
    if (mr.current?.state === 'recording') mr.current.stop(); else onCancel();
  };
  return (
    <div className="flex items-center gap-2 bg-rose-50 border border-rose-200 rounded-2xl px-3 py-1.5" data-testid="chat-voice-recording">
      <span className="w-2.5 h-2.5 rounded-full bg-rose-600 animate-pulse" />
      <span className="text-sm font-semibold text-rose-700 tabular-nums" data-testid="chat-voice-timer">{Math.floor(secs / 60)}:{String(secs % 60).padStart(2, '0')}</span>
      <span className="text-xs text-rose-600 flex-1 truncate">A gravar nota de voz…</span>
      <button type="button" onClick={() => stop(true)} title="Cancelar" className="p-1.5 text-slate-500 hover:text-rose-700" data-testid="chat-voice-cancel"><Trash2 className="w-4 h-4" /></button>
      <button type="button" onClick={() => stop(false)} title="Parar e enviar" className="p-2 rounded-full bg-rose-600 text-white hover:bg-rose-700" data-testid="chat-voice-stop"><Square className="w-3.5 h-3.5" /></button>
    </div>
  );
};
